// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PbOt","left":"styles_left__3p-KV"};